import styled from 'styled-components/macro';
import { ReactComponent as InformationIcon } from 'icons/icon-info.svg';

export const InfoIcon = styled(InformationIcon)`
  width: 0.875rem;
  height: 0.875rem;
  cursor: pointer;

  circle,
  path {
    stroke: ${({ theme }): string => theme.DeepBlue};
  }
`;
